import React from "react";

const DoubleCheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="double_check_icon"
      data-name="double check"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99512 11.4517L5.94762 14.4684L12.2943 7.21507L11.0393 6.11841L5.71928 12.1984L3.00512 10.1267L1.99512 11.4517ZM18.1276 7.21507L16.8726 6.11841L11.5651 12.1842L10.9376 11.6826L9.89595 12.9842L11.7684 14.4826L18.1276 7.21507Z"
        fill={props.fill || "#B9CED5"}
      />
    </svg>
  );
};

export default DoubleCheckIcon;
